import React, { Component, Suspense } from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { isMobileOnly } from "react-device-detect";
import { emptyCacheStorage } from "./i18n";
import configureStore, { history } from "./store/configure";
import MainLayout from "./containers/MainLayout";
import ReactGA from "react-ga";
import { authActionCreators } from "./store/auth/actions";
import { isProd } from "./utils/isProd";
import LoadingLogo from "./static/images/LoadingLogo.png";
import { watchChallengeModal } from "./utils/responseInterceptor";
import "./App.scss";

const store = configureStore();

const Loader = () => (
  <div className="App">{isMobileOnly ? <img className="loading-logo" src={LoadingLogo} alt="" /> : <div></div>}</div>
);

const KEY = isProd() ? "UA-136068254-3" : "UA-136068254-4";
//Unique Google Analytics tracking number
ReactGA.initialize(KEY);

watchChallengeModal(store);
class App extends Component {
  componentWillMount() {
    emptyCacheStorage();
    const accessToken = localStorage.getItem("accessToken");
    const clientId = localStorage.getItem("clientId");
    const clientName = localStorage.getItem("clientName");
    const url = new URL(window.location.href);
    const searchToken = url.searchParams.get("accessToken");
    const searchClientId = url.searchParams.get("clientId");
    const searchClientName = url.searchParams.get("clientName");
    if (accessToken) {
      store.dispatch(
        authActionCreators.loginSuccess({
          token: accessToken,
          clientId,
          clientName,
        }),
      );
    } else if (searchToken) {
      store.dispatch(
        authActionCreators.loginSuccess({
          token: searchToken,
          clientId: searchClientId,
          clientName: searchClientName,
        }),
      );
    } else {
      localStorage.setItem("redirectUrl", window.location.pathname);
    }
  }

  render() {
    return (
      <Provider store={store}>
        <Suspense fallback={<Loader />}>
          <Router location={history.location} navigator={history}>
            <MainLayout />
          </Router>
        </Suspense>
      </Provider>
    );
  }
}

export default App;
